import { Helmet } from "react-helmet-async";

const SITE_URL = "https://proimpact.ch";
const SITE_NAME = "ProImpact Carrosserie Genève";
const DEFAULT_OG_IMAGE = "https://storage.googleapis.com/gpt-engineer-file-uploads/ZsA5nC7rcffOxM1xLcuvySEdAHE3/social-images/social-1772549415385-Photoroom_20260303_154916.webp";

interface SEOHeadProps {
  title: string;
  description: string;
  canonicalPath?: string;
  ogImage?: string;
  ogType?: string;
  noindex?: boolean;
  publishedTime?: string;
  modifiedTime?: string;
}

const SEOHead = ({
  title,
  description,
  canonicalPath = "/",
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  noindex = false,
  publishedTime,
  modifiedTime,
}: SEOHeadProps) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`${SITE_URL}${canonicalPath}`} />

    {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />}

    <meta property="og:type" content={ogType} />
    <meta property="og:url" content={`${SITE_URL}${canonicalPath}`} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={ogImage} />
    <meta property="og:locale" content="fr_CH" />
    <meta property="og:site_name" content={SITE_NAME} />

    {ogType === "article" && publishedTime && (
      <meta property="article:published_time" content={publishedTime} />
    )}
    {ogType === "article" && modifiedTime && (
      <meta property="article:modified_time" content={modifiedTime} />
    )}
    {ogType === "article" && (
      <meta property="article:author" content={SITE_NAME} />
    )}

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={ogImage} />
  </Helmet>
);

export default SEOHead;
